
(() => {
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.submitBtn = this.form.querySelector('[type="submit"], button[name="add"]');
      this.errorBox = this.querySelector('[data-form-error]');
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }

    async onSubmit(e) {
      e.preventDefault();
      if (this.submitBtn?.hasAttribute('disabled')) return;
      this.setLoading(true);
      this.showError('');

      const formData = new FormData(this.form);
      const items = [{
        id: Number(formData.get('id')),
        quantity: Number(formData.get('quantity') || 1),
        properties: this.collectProperties(formData),
      }];

      try {
        await window.CartAPI.add(items, { source: 'product-form' });
        const drawerId = this.dataset.openDrawer ?? 'cart-drawer';
        if (drawerId) document.getElementById(drawerId)?.open?.(this.submitBtn);
        this.flashAdded();
      } catch (err) {
        this.showError(err.message || window.themeStrings?.cartError || 'Something went wrong');
      } finally {
        this.setLoading(false);
      }
    }

    collectProperties(formData) {
      const props = {};
      for (const [key, value] of formData.entries()) {
        const m = key.match(/^properties\[(.+)\]$/);
        if (m && value !== '') props[m[1]] = value;
      }
      return Object.keys(props).length ? props : undefined;
    }

    setLoading(on) {
      this.submitBtn?.toggleAttribute('disabled', on);
      this.submitBtn?.classList.toggle('is-loading', on);
      this.querySelector('[data-atc-spinner]')?.toggleAttribute('hidden', !on);
    }

    flashAdded() {
      const label = this.querySelector('[data-atc-text]');
      if (!label) return;
      const original = label.textContent;
      label.textContent = window.themeStrings?.addedToCart || 'Added!';
      setTimeout(() => { label.textContent = original; }, 1600);
    }

    showError(message) {
      if (!this.errorBox) return;
      this.errorBox.textContent = message;
      this.errorBox.toggleAttribute('hidden', !message);
    }
  }

  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);
})();
